module.exports = __webpack_public_path__ + "static/media/cap1-leg-mob.00ad8cd2.png";